// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__FKTDO","cell":"style_cell__1WSCX","approvalGrid":"style_approvalGrid__6pEPH"};